import { CommunityModel } from '../models/Community.model';
import { CommunityDTO } from '../dtos/Community.dto';
import {
  CommunityPushRequestDTO,
  CommunityRequestDTO,
} from '../dtos/CommunityRequest.dto';

export class CommunityUtil {
  public static mapToViewModel(dto: CommunityDTO): CommunityModel {
    return {
      id: dto.id,
      name: dto.name,
      logo: dto.logo ? dto.logo : undefined,
      androidBundleId: dto.androidBundleId,
      iosBundleId: dto.iosBundleId,
      appVersion: dto.appVersion,
      status: dto.status,
      contactPermission: dto.contactPermission ? dto.contactPermission : false,
      subscription: dto.tier.subscription,
      population: dto.population,
      updates: dto.appUpdates
        ? dto.appUpdates.map((item) => {
            return {
              identifier: item.identifier,
              release: item.releaseDate,
              version: item.appVersion,
            };
          })
        : [],
    };
  }

  public static toPushRequestDTO(
    model?: CommunityModel,
  ): CommunityPushRequestDTO {
    return {
      APN: {
        id: model ? model.id : undefined,
        apn: '',
        apn_key_id: '',
        apn_team_id: '',
      },
      GCM: {
        id: model ? model.id : undefined,
        gcm: '',
      },
    };
  }

  public static toRequestDTO(model?: CommunityModel): CommunityRequestDTO {
    return {
      id: model ? model.id : undefined,
      name: model ? model.name : '',
      androidBundleId: model ? model.androidBundleId : '',
      iosBundleId: model ? model.iosBundleId : '',
      appVersion: model ? model.appVersion : undefined,
      logo: model ? model.logo : undefined,
      contactPermission: model ? model.contactPermission : undefined,
      subscription: model ? model.subscription : undefined,
      population: model ? model.population : undefined,
      updates: model
        ? model.updates.map((item) => {
            return {
              appVersion: item.version,
              identifier: item.identifier,
              releaseDate: new Date(item.release),
            };
          })
        : [],
    };
  }
}
